import { evaluate } from "mathjs";
import { convertEmptyValueToZero } from "../helpers/methods";

const FormulaService = {
  findTagsInFormula: function (formulaValue, removePrefixAndSuffix = true) {
    const regex = /\[([^\]]+)\]/g;
    const matches = formulaValue.match(regex);

    let tags = matches;
    if (!tags) return [];

    if (removePrefixAndSuffix) {
      tags = matches.map((match) => match.slice(1, -1));
    }
    return tags;
  },

  calculateMathFormula: function (mathFormula) {
    try {
      const result = evaluate(mathFormula);
      return result;
    } catch (error) {
      return null;
    }
  },

  calculateFormula: function (formulaValue, objectData) {
    const tags = this.findTagsInFormula(formulaValue, false);
    for (const tag of tags) {
      formulaValue = formulaValue.replace(
        tag,
        convertEmptyValueToZero(objectData[tag.slice(1, -1)])
      );
    }
    return this.calculateMathFormula(formulaValue);
  },

  validateMathFormula: function (dataToSend, shouldIncludeTags = true) {
    let formula = dataToSend.equipscheme_scripts;

    const tags = this.findTagsInFormula(formula);

    if (shouldIncludeTags && tags.length === 0) return false;

    for (const tag of tags) {
      formula = formula.replace(tag, 1);
    }

    const result = this.calculateMathFormula(formula);

    return result !== null && result?._data[0] !== Infinity;
  },
};

export default FormulaService;
